<template>
  <div>
    <div v-if="$store.getters.canUseStorage && encodingAccounts && encodingAccounts.length === 0">
      <div class="w-full flex py-8 px-6 videoEncoder">
        <div
          class="
            w-full
            flex flex-col flex-nowrap
            items-center
            justify-center
          "
        >
          <div
            class="
              w-24
              h-24
              rounded-full
              bg-grey-300
              flex
              items-center
              justify-center
              m-auto
            "
          >
            <img
              src="./assets/images/videos/Storage-Icon.png"
              alt="Storage-Icon"
            />
          </div>
          <h3 class="mt-6 mb-2">
            {{
              $t(
                'frontend_groovevideo_members_settings_index_lets_setup_encoder'
              )
            }}
          </h3>
          <p class="text-sm mb-3 text-grey-500 text-center w-2/5">
            <strong class="text-black mb-2">
              {{
                $t(
                  'frontend_groovevideo_members_settings_index_promembers_get'
                )
              }} </strong
            ><br />
            {{
              $t(
                'frontend_groovevideo_members_settings_index_as_you_are'
              )
            }}
          </p>
          <p class="mb-3 text-center w-2/5">
            <strong>OR</strong>
            <br />
            <span class="text-grey-900">
              Connect your own encoder account
            </span>
          </p>
          <div
            class="
              w-full
              mt-3
              flex
              justify-center
              items-center
              smallBox
            "
          >
            <div
              class="
                flex flex-col
                justify-center
                items-center
                border-grey-300 border border-solid
                rounded-md
                cursor-pointer
                mr-4
              "
              @click="addEncodeIntegration(1)"
            >
              <img
                src="./assets/images/videos/coconut-logo-white.png"
                alt="coconut-logo-white"
              />
              <a href="#" class="text-pink text-sm mt-6">
                {{
                  $t(
                    'frontend_groovevideo_members_settings_index_connect_coconut'
                  )
                }}
              </a>
            </div>
            <div
              class="
                flex flex-col
                justify-center
                items-center
                border-grey-300 border border-solid
                rounded-md
                cursor-pointer
              "
              @click="addEncodeIntegration(2)"
            >
              <img
                src="./assets/images/videos/Encoding_90grey.png"
                alt="Encoding_90grey"
              />
              <a href="#" class="text-pink text-sm mt-6">
                {{
                  $t(
                    'frontend_groovevideo_members_settings_index_connect_encoding'
                  )
                }}
              </a>
            </div>
          </div>
          <p class="text-sm text-grey-500 mt-4">
            {{
              $t(
                'frontend_groovevideo_members_settings_index_need_help_connecting'
              )
            }}
            <a href="#" class="text-pink">
              {{
                $t(
                  'frontend_groovevideo_members_settings_index_visit_help_center'
                )
              }}
            </a>
          </p>
        </div>
      </div>
    </div>
    <div v-else>
      <div
        v-if="encodingAccounts.length >= 1"
        class="flex flex-row justify-end w-full"
      >
        <div class="text-right mt-2">
          <dropdown-button class="w-full">
            <span
              slot="link"
              class="
                w-full
                flex
                items-center
                inline-block
                font-medium
                pl-3
                pr-2
                py-1
                rounded
                bg-pink
                text-white
              "
            >
              <span class="mr-1 pr-2"
                >+
                {{
                  $t(
                    'frontend_groovevideo_members_settings_index_add_new_encoder'
                  )
                }}
              </span>
              <i class="fas fa-angle-down" />
            </span>
            <div
              slot="dropdown"
              class="
                bg-white
                shadow
                rounded
                border border-grey-300
                overflow-hidden
              "
            >
              <div
                v-for="(integration, index) in encodingIntegration"
                :key="index"
                class="
                  no-underline
                  block
                  p-2
                  text-grey-darkest
                  bg-white
                  cursor-pointer
                  text-sm
                "
                @click="addEncodeIntegration(integration.id)"
              >
                {{ integration.name }}
              </div>
            </div>
          </dropdown-button>
        </div>
      </div>
      <div>
        <div
          v-if="encodingAccounts.length > 0"
          class="flex flex-wrap w-full "
        >
          <info-panel
            v-for="(encoding, encodingIndex) in encodingAccounts"
            :key="encodingIndex"
            class="my-4 mx-2 storage-section relative"
          >
            <template slot="content">
              <div class="w-full h-full flex items-center justify-center p-4">
                <img
                  v-if="encoding.type == 1"
                  src="./assets/images/logo/coconut.png"
                  alt="content-img"
                  class="responsive h-16 mx-auto"
                />
                <img
                  v-else
                  src="./assets/images/logo/Encoding.png"
                  alt="content-img"
                  class="responsive h-16 mx-auto"
                />
              </div>
            </template>
            <template slot="footer">
              <div class="flex w-full mt-6 px-4 justify-between">
                <div
                  class="text-sm text-black font-semibold capitalize"
                >
                  {{ encoding.integration_name }}
                </div>
                <div
                  class="text-grey-700 cursor-pointer"
                  @click="deleteEncoder(encoding.id)"
                >
                  <i class="fas fa-trash" />
                </div>
              </div>
            </template>
          </info-panel>
        </div>
          <div v-else class="w-full">
            <div class="w-full flex py-8 px-6 videoEncoder">
              <div
                class="
                  w-full
                  flex flex-col flex-nowrap
                  items-center
                  justify-center
                "
              >
                <div
                  class="
                    w-24
                    h-24
                    rounded-full
                    bg-grey-300
                    flex
                    items-center
                    justify-center
                    m-auto
                  "
                >
                  <img
                    src="./assets/images/videos/Storage-Icon.png"
                    alt="Storage-Icon"
                  />
                </div>
                <h3 class="mt-6 mb-2">
                  {{
                    $t(
                      'frontend_groovevideo_members_settings_index_lets_setup_encoder'
                    )
                  }}
                </h3>
                <p class="text-sm mb-6 text-grey-500 text-center w-7/12">
                  <strong class="text-black">
                    {{
                      $t(
                        'frontend_groovevideo_members_settings_index_free_encoder'
                      )
                    }} </strong
                  ><br />
                  {{
                    $t(
                      'frontend_groovevideo_members_settings_index_free_members_need'
                    )
                  }}
                </p>
                <div
                  class="
                    w-full
                    flex flex-col flex-nowrap
                    items-center
                    justify-center
                  "
                >
                  <gd-button
                    v-if="this.$store.getters.canUseStorage"
                    primary
                    class="px-4 w-auto py-4"
                  >
                    {{
                      $t(
                        'frontend_groovevideo_members_settings_index_upgrade_to_pro'
                      )
                    }}
                  </gd-button>
                  <gd-button
                    v-else
                    primary
                    class="px-2 w-7/12 h-auto py-2"
                  >
                    {{
                      $t(
                        'frontend_groovevideo_members_settings_index_pro_users_get_free'
                      )
                    }}
                  </gd-button>
                </div>
                <div
                  class="
                    w-full
                    mt-4
                    flex
                    justify-center
                    items-center
                    smallBox
                  "
                >
                  <div
                    class="
                      flex flex-col
                      justify-center
                      items-center
                      border-grey-300 border border-solid
                      rounded-md
                      cursor-pointer
                      mr-4
                    "
                    @click="addEncodeIntegration(1)"
                  >
                    <img
                      src="./assets/images/videos/coconut-logo-white.png"
                      alt="coconut-logo-white"
                    />
                    <a href="#" class="text-pink text-sm mt-6">
                      {{
                        $t(
                          'frontend_groovevideo_members_settings_index_connect_coconut'
                        )
                      }}
                    </a>
                  </div>
                  <div
                    class="
                      flex flex-col
                      justify-center
                      items-center
                      border-grey-300 border border-solid
                      rounded-md
                      cursor-pointer
                    "
                    @click="addEncodeIntegration(2)"
                  >
                    <img
                      src="./assets/images/videos/Encoding_90grey.png"
                      alt="Encoding_90grey"
                    />
                    <a href="#" class="text-pink text-sm mt-6">
                      {{
                        $t(
                          'frontend_groovevideo_members_settings_index_connect_encoding'
                        )
                      }}
                    </a>
                  </div>
                </div>
                <p class="text-sm text-grey-500 mt-4">
                  {{
                    $t(
                      'frontend_groovevideo_members_settings_index_need_help_connecting'
                    )
                  }}
                  <a href="#" class="text-pink">
                    {{
                      $t(
                        'frontend_groovevideo_members_settings_index_visit_help_center'
                      )
                    }}
                  </a>
                </p>
              </div>
            </div>
          </div>
      </div>
    </div>
    <gd-modal
      name="add-coconut-account-modal"
      :title="$t('frontend_groovevideo_add_coconut_account_details')"
      @closed="resetModal"
    >
      <div class="flex flex-col m-6">
        <div class="flex flex-col w-full mb-4">
          <label class="font-semibold text-sm text-grey-700 mb-2">
            {{
              $t(
                'frontend_groovevideo_members_settings_index_integration_name'
              )
            }}
          </label>
          <text-input
            v-model="model.name"
            :validator="$v.model.name"
            value="model.name"
            :attribute="$t('frontend_name')"
            :placeholder="
              $t(
                'frontend_groovevideo_members_settings_index_integration_name'
              )
            "
          />
        </div>
        <div class="flex flex-col w-full mb-4">
          <label class="font-semibold text-sm text-grey-700 mb-2">
            {{ $t('frontend_groovevideo_members_settings_index_apikey') }}
          </label>
          <text-input
            v-model="model.apikey"
            :validator="$v.model.apikey"
            value="model.apikey"
            :attribute="$t('frontend_groovevideo_videos_integration_key')"
            :placeholder="
              $t('frontend_groovevideo_members_settings_index_apikey')
            "
          />
        </div>
        <div class="flex flex-row w-full justify-end">
          <gd-button
            class="text-center w-40"
            size="large"
            primary
            @click="saveCoconutAccount"
          >
            {{ $t('frontend_groovevideo_members_settings_create') }}
          </gd-button>
        </div>
      </div>
    </gd-modal>

    <gd-modal name="add-encoding-account-modal" :title="$t('frontend_groovevideo_add_details')" @closed="resetModal">
      <div class="flex flex-col m-6">
        <div class="flex flex-col w-full mb-4">
          <label class="font-semibold text-sm text-grey-700 mb-2">
            {{
              $t(
                'frontend_groovevideo_members_settings_index_integration_name'
              )
            }}
          </label>
          <text-input
            v-model="model.integration_name"
            :validator="$v.model.integration_name"
            value="model.integration_name"
            :attribute="$t('frontend_name')"
            :placeholder="
              $t(
                'frontend_groovevideo_members_settings_index_enter_integration_name'
              )
            "
          />
        </div>
        <div class="flex flex-col w-full mb-4">
          <label class="font-semibold text-sm text-grey-700 mb-2">
            {{ $t('frontend_groovevideo_members_settings_index_user_id') }}
          </label>
          <text-input
            v-model="model.user_encode_id"
            :validator="$v.model.user_encode_id"
            value="model.apikey"
            :attribute="$t('frontend_groovevideo_members_settings_index_user_id')"
            :placeholder="
              $t('frontend_groovevideo_members_settings_index_user_id')
            "
          />
        </div>
        <div class="flex flex-col w-full mb-4">
          <label class="font-semibold text-sm text-grey-700 mb-2">
            {{ $t('frontend_groovevideo_members_settings_index_user_key') }}
          </label>
          <text-input
            v-model="model.user_encode_key"
            :validator="$v.model.user_encode_key"
            value="model.user_encode_key"
            :attribute="$t('frontend_groovevideo_videos_integration_key')"
            :placeholder="
              $t('frontend_groovevideo_members_settings_index_user_key')
            "
          />
        </div>
        <div class="flex flex-row w-full justify-end">
          <gd-button
            class="text-center w-40"
            size="large"
            primary
            @click="saveEncodingComCredential"
          >
            {{ $t('frontend_groovevideo_members_settings_create') }}
          </gd-button>
        </div>
      </div>
    </gd-modal>
  </div>
</template>
<script>
import Swal from 'sweetalert2';
import { required, minLength, maxLength } from 'vuelidate/lib/validators';
import Encoder from './models/Encoder';

export default {
  props: {
    encodingAccounts: {
      required: true,
    }, 
  },
  components: {},
  data () {
    return {
      model: {
        name: '',
        apikey: '',
        integration_name: '',
        user_encode_id: '',
        user_encode_key: '',
      },
    };
  },
  validations: {
    model: {
      name: {
        required,
        minLength: minLength(3),
        maxLength: maxLength(100),
      },
      apikey: {
        required,
        maxLength: maxLength(100),
      },
      integration_name: {
        required,
        minLength: minLength(3),
        maxLength: maxLength(100),
      },
      user_encode_id: {
        required,
        minLength: minLength(3),
        maxLength: maxLength(100),
      },
      user_encode_key: {
        required,
        minLength: minLength(3),
        maxLength: maxLength(100),
      },
    },
  },
  computed: {
    encodingIntegration() {
      return [
        { name: this.$t('frontend_groovevideo_add_coconut_encoding'), id: 1 },
        {
          name: this.$t('frontend_groovevideo_add_encoding_integration'),
          id: 2,
        },
      ];
    },
  },
  methods: {
    addEncodeIntegration(id) {
      if (id === 1) {
        this.$root.$emit('modal-open', 'add-coconut-account-modal');
      } else if (id === 2) {
        this.$root.$emit('modal-open', 'add-encoding-account-modal');
      }
    },
    resetModal () {
      this.model = {
        name: '',
        apikey: '',
        integration_name: '',
        user_encode_id: '',
        user_encode_key: '',
      };
      this.$v.$reset();
    },
    async saveCoconutAccount() {
      this.$v.model.name.$touch();
      this.$v.model.apikey.$touch();
      if (!this.$v.model.name.$invalid &&
        !this.$v.model.apikey.$invalid) {
        this.$emit('setIsLoading', true);
        this.encoder = new Encoder({});
        this.encoder.type = 1;
        this.encoder.apikey = this.model.apikey;
        this.encoder.integration_name = this.model.name;

        const self = this;
        this.encoder
          .save()
          .then((response) => {
            self.encoder = response.data;
            self.encodingAccounts.push(self.encoder);
            self.$root.$emit('modal-close', 'add-coconut-account-modal');
            self.resetModal();
            self.$emit('setIsLoading', false);
          })
          .catch(() => {
            self.$emit('setIsLoading', false);
          });
      }
    },


    saveEncodingComCredential() {
      this.$v.model.integration_name.$touch();
      this.$v.model.user_encode_id.$touch();
      this.$v.model.user_encode_key.$touch();

      if (
        !this.$v.model.integration_name.$invalid &&
        !this.$v.model.user_encode_id.$invalid &&
        !this.$v.model.user_encode_key.$invalid
      ) {
        this.$emit('setIsLoading', true);
        this.encoder = new Encoder({});
        this.encoder.type = 2;
        this.encoder.integration_name = this.model.integration_name;
        this.encoder.user_encode_id = this.model.user_encode_id;
        this.encoder.user_encode_key = this.model.user_encode_key;

        const self = this;

        this.encoder
          .save()
          .then((response) => {
            if (response.error) {
              Swal.fire(this.$t('frontend_error'), response.error, 'error');
            } else {
              self.encoder = response.data;
              self.encodingAccounts.push(self.encoder);
            }

            self.$root.$emit('modal-close', 'add-encoding-account-modal');
            self.resetModal();
            self.$emit('setIsLoading', false);
          })
          .catch(() => {
            self.$emit('setIsLoading', false);
          });
      }
    },
    async deleteEncoder (id) {
      const { value: accept } = await Swal.fire({
        title: this.$t('frontend_sure'),
        text: this.$t('frontend_non_revertable'),
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: this.$t('frontend_delete_confirm'),
      });
      
      if (accept) {
        this.$emit('setIsLoading', true);
        const encoder = await Encoder.$find(id);
        const response = await encoder.delete();

        if (
          typeof response.data !== 'undefined' &&
          typeof response.data.status !== 'undefined' &&
          response.data.status == true
        ) {
            const deletedEncoder = this.encodingAccounts.findIndex(el => el.id === id);
            this.encodingAccounts.splice(deletedEncoder, 1);
        } else {
          Swal.fire( this.$t('frontend_groovevideo_warning_title'), response.data.message, 'warning' ); 
        }
        this.$emit('setIsLoading', false);
      }
    },
  },
};
</script>
<style>
.videoEncoder h3 {
  font-size: 20px !important;
  color: #191d3a;
}
.storage-section {
  width: 23.5% !important;
  height: 267px !important;
  min-width: 250px !important;
}
.storage-section .rounded-md-top {
  border-radius: 4px 4px 0px 0px !important;
}
.smallBox div {
  width: 182px;
  height: 104px;
  border-radius: 5px;
}
</style>